/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from '@efexteam/components';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box, IconButton, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IFilterByDate {
  onChange: (item: any) => void;
}

const FilterByDate = ({ onChange }: IFilterByDate) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState<DateTime | null>(null);
  const [endDate, setEndDate] = useState<DateTime | null>(null);

  const filterDates = () => {
    if (!startDate || !endDate) return;
    const startD = startDate?.toISODate();
    const endD = endDate?.toISODate();
    onChange({ dateFrom: startD, dateTo: endD });
  };

  const clearSearch = () => {
    setStartDate(null);
    setEndDate(null);
    onChange({ dateFrom: undefined, dateTo: undefined });
  };

  return (
    <Box className="w-full">
      <Typography className="block">{t('filterByDate')}</Typography>
      <Box className="my-4 flex flex-col md:flex-row flex-wrap gap-3 justify-start items-end w-full">
        <DatePicker
          label={t('startDate')}
          className="w-full lg:w-auto"
          value={startDate}
          onChange={(newValue) => setStartDate(newValue as DateTime)}
          disableFuture
        />
        <DatePicker
          label={t('endDate')}
          className="w-full lg:w-auto"
          value={endDate}
          onChange={(newValue) => setEndDate(newValue as DateTime)}
          disableFuture
        />
        <Box className="w-full lg:w-auto">
          <Button
            appearance="primary"
            size="medium"
            variant={!startDate || !endDate ? 'outlined' : 'contained'}
            onClick={filterDates}
            disabled={!startDate || !endDate}
          >
            {t('filter')}
          </Button>
          <IconButton
            color="error"
            disabled={!endDate && !startDate}
            onClick={clearSearch}
            aria-label="clear"
          >
            <HighlightOffIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default FilterByDate;
